export const TAG = "[SMSLogs]";
export const MODULE_TITLE = "SMS Logs";
export const SLICE = "smsLogsSlice";
export const searchColumns = [
  "action_agent",
  "action_taken",
  "action_time",
  "coins_deducted",
  "id",
  "lead",
  "notes",
  "provider",
  "received_time",
  "receiver_details",
  "rule",
  "sms_text",
  "sms_type",
  "sr_number",
];

export const ANALYTICS = {
  ADVANCE_FILTERS_CLICKED: "Advance Filters",
  SEARCH_USAGE: "Search",
  PAGINATION: "Paginated",
  PAGE_VIEWED: "SMS Page View",
};
